export const DATE_FORMATS = {
  DATE_WITH_TIME: "DD/MM/YYYY h:mm"
}
